import { render } from "./InputPage.vue?vue&type=template&id=c7cf2b68&scoped=true"
import script from "./InputPage.vue?vue&type=script&lang=js"
export * from "./InputPage.vue?vue&type=script&lang=js"

import "./InputPage.vue?vue&type=style&index=0&id=c7cf2b68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7cf2b68"]])

export default __exports__